<template>
  <a-layout-footer class='footer'>技术支持：{{config.COMPANYNAME}}</a-layout-footer>
</template>
<script>
import config from '@/config'
export default {
  name: "AppFooter",
  props: {},
  data() {
    return {
      config
    };
  },
};
</script>